export const featureTypeToCollection = {
  challenge: "profiles",
  team: "userTeamJunction",
  news: "news",
};
